export default __webpack_public_path__ + "static/media/Arch_Amazon-CloudFront_64.aaf98a71.svg";